import { Constants } from '@hvf/contracts'
import * as v from 'valibot'

export const RecordingSchema = v.pipe(
	v.object({
		// Keep these as nullable/optional so they can be empty
		event_id: v.nullable(v.string()),
		hosted_by: v.nullable(v.string()),
		title: v.string(),
		group: v.nullable(v.string()),
		evergreen: v.optional(v.boolean()),
		description: v.optional(
			v.pipe(
				v.string(),
				v.maxLength(1000, 'Description must be less than 1000 characters'),
			),
		),
		provider_id: v.pipe(v.string(), v.minLength(1, 'Provider ID is required')),
		provider: v.picklist(Constants.public.Enums.video_providers),
		occurrence_date: v.pipe(v.string(), v.minLength(1, 'Date is required')),
	}),
)

export type RecordingForm = v.InferInput<typeof RecordingSchema>
